import type { TableData } from "@/lib/chat-types";
import { renderInlineBold } from "./RenderInlineBold";

export function TableBlock({ table }: { table: TableData }) {
  return (
    <div className="border border-[var(--color-border)] rounded-lg overflow-hidden my-2 w-full overflow-x-auto">
      <table className="w-full text-xs" style={{ borderCollapse: "collapse" }}>
        <thead>
          <tr>
            {table.headers.map((h, i) => (
              <th
                key={i}
                className="px-3 py-2 text-left text-[10px] font-semibold uppercase tracking-wider bg-[var(--color-border)]/30 border-b border-[var(--color-border)] text-[var(--color-fg-secondary)]"
                style={{ fontFamily: "var(--font-mono)" }}
              >
                {h}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {table.rows.map((row, ri) => (
            <tr key={ri}>
              {row.map((cell, ci) => (
                <td
                  key={ci}
                  className="px-3 py-2 text-[var(--color-fg-secondary)] leading-relaxed"
                  style={{ borderBottom: ri < table.rows.length - 1 ? "1px solid var(--color-border)" : "none" }}
                >
                  {renderInlineBold(cell)}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
